import type { Directive, DirectiveBinding } from 'vue'
import Clipboard from 'clipboard'

interface ClipboardElement extends HTMLElement {
  _v_clipboard?: Clipboard
  _v_clipboard_success?: (e: Clipboard.Event) => void
  _v_clipboard_error?: (e: Clipboard.Event) => void
}

const clipboardDirective: Directive = {
  beforeMount(el: ClipboardElement, binding: DirectiveBinding) {
    if (binding.arg === 'success') {
      el._v_clipboard_success = binding.value
    } else if (binding.arg === 'error') {
      el._v_clipboard_error = binding.value
    } else {
      const clipboard = new Clipboard(el, {
        text: () => binding.value,
        action: () => binding.arg === 'cut' ? 'cut' : 'copy'
      })
      clipboard.on('success', (e) => {
        const callback = el._v_clipboard_success
        callback?.(e)
      })
      clipboard.on('error', (e) => {
        const callback = el._v_clipboard_error
        callback?.(e)
      })
      el._v_clipboard = clipboard
    }
  },

  updated(el: ClipboardElement, binding: DirectiveBinding) {
    if (binding.arg === 'success') {
      el._v_clipboard_success = binding.value
    } else if (binding.arg === 'error') {
      el._v_clipboard_error = binding.value
    } else if (el._v_clipboard) {
      ;(el._v_clipboard as unknown as { text: () => string }).text = () => binding.value
      ;(el._v_clipboard as unknown as { action: () => 'cut' | 'copy' }).action = () =>
        binding.arg === 'cut' ? 'cut' : 'copy'
    }
  },

  unmounted(el: ClipboardElement, binding: DirectiveBinding) {
    if (binding.arg === 'success') {
      delete el._v_clipboard_success
    } else if (binding.arg === 'error') {
      delete el._v_clipboard_error
    } else {
      el._v_clipboard?.destroy()
      delete el._v_clipboard
    }
  }
}

export default clipboardDirective
